import { DefermentEligibleWorkOrder, Response } from "../../types";
import {
  ChangePriorityResponse,
  WonosStatusResponse,
} from "../../types/woTypes";
import { downloadAndSaveFile } from "../../utils";
import {
  buildResponse,
  callWorkflowGET,
  callWorkflowGET_V3,
  callWorkflowPUT,
} from "../generic";
import { WO_ENDPOINTS } from "./endpoints";
export interface WoPriorityRequest {
  vesselCode: string;
  woNumber: string;
  newStatus: number;
}

export interface WoPriorityBody {
  new_status: number;
}

export const putWoPriority = (
  { vesselCode, woNumber, newStatus }: WoPriorityRequest,
  setWo: (obj: Response<ChangePriorityResponse>) => void,
): void => {
  const response = callWorkflowPUT<
    ChangePriorityResponse,
    { new_status: number }
  >(WO_ENDPOINTS.VESSEL_WO_STATUS_UPDATE(vesselCode, woNumber), {
    new_status: newStatus,
  } as WoPriorityBody);

  buildResponse<ChangePriorityResponse>(response, setWo);
};

export const getWOsStatus = (
  vesselCode: string,
  setWonoStatus: (obj: Response<WonosStatusResponse[]>) => void,
  tag_code?: string,
): void => {
  const response = callWorkflowGET<WonosStatusResponse[]>(
    WO_ENDPOINTS.VESSEL_WO_STATUS(vesselCode),
    {
      params: { tag_code },
    },
  );

  buildResponse<WonosStatusResponse[]>(response, setWonoStatus);
};

export const getWorkOrdersForTagSlice = async (
  vesselId: string,
  selectedTag: string,
): Promise<WonosStatusResponse[]> =>
  callWorkflowGET(
    `${WO_ENDPOINTS.VESSEL_WO_STATUS(vesselId)}?tag_code=${selectedTag}`,
  );

export const getWOStatusExport = (vesselCode: string, format: string) => {
  const endpoint = WO_ENDPOINTS.VESSEL_WO_STATUS(vesselCode);
  const fileName = `${vesselCode}_WOs`;
  downloadAndSaveFile(endpoint, fileName, format);
};

export const getPreventiveWorkOrdersEligibleForDeferment = (
  vesselCode: string,
  tagCode: string,
  setObject: (response: Response<DefermentEligibleWorkOrder[]>) => void,
): void => {
  const response = callWorkflowGET_V3<DefermentEligibleWorkOrder[]>(
    WO_ENDPOINTS.VESSEL_TAG_PREVENTIVE_WOS(vesselCode, tagCode),
    {
      params: {
        eligible_for_deferment: true,
      },
    },
  );
  buildResponse(response, setObject);
};
